import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from "@sentry/angular";
import { SUPERTOKEN_URL } from 'environments/environment';
import Session from 'supertokens-web-js/recipe/session';
import SuperTokens from 'supertokens-web-js';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword'

Sentry.init({
  dsn: "https://996e3a9db31c1e09b053396826e1ceaf@o4508954516652032.ingest.us.sentry.io/4508954518814720",
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: "system",
      triggerLabel: "Send Feedback/Bug Report",
      formTitle: "Send Feedback/Bug Report",
      submitButtonLabel: "Send"
    }),
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/localhost\/api/],
});

SuperTokens.init({
  appInfo: {
    appName: "Private Banking Strategies App",
    apiDomain: SUPERTOKEN_URL,
    apiBasePath: "/api",
  },
  recipeList: [
    Session.init({
      tokenTransferMethod: "header"
    }),
    EmailPassword.init()
  ]
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
